import { useState } from 'react';
import {useAppSelector} from '@/store/hooks.js';
import {gql} from '@apollo/client';
import apolloClient from '@/services/apolloClient.js';
import {useTranslation} from 'react-i18next';

const useAddRetributionModel = () => {
    const {t} = useTranslation('global');

    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const authUser = useAppSelector((state) => state.auth.currentUser);
    const addRetributionModel = async (upToFiveConsultants, upToTenConsultants, moreThanTenConsultants) => {
        setLoading(true);
        setError(null);
        try {
            const toNumericLiteral = (value) => {
                const number = Number(value);
                if (!Number.isFinite(number) || !String(value ?? '').trim()) {
                    throw new Error(t('error.wrongFormat'));
                }
                return String(number);
            };
            const companyUuid = authUser?.company?.uuid;
            const mutation = gql(`
                mutation addRetributionModel($companyUuid: ID!) {
                    addRetributionModel(newRetributionModel: {
                        upToFiveConsultants: ${toNumericLiteral(upToFiveConsultants)},
                        upToTenConsultants: ${toNumericLiteral(upToTenConsultants)},
                        moreThanTenConsultants: ${toNumericLiteral(moreThanTenConsultants)},
                        companyUuid: $companyUuid
                    }) {
                        uuid
                        upToTenConsultants
                        upToFiveConsultants
                        moreThanTenConsultants
                    }
                }
            `);
            const result = await apolloClient.mutate({
                mutation,
                variables: { companyUuid },
                errorPolicy: 'none',
            });
            const data = result.data?.addRetributionModel;
            setResponse(data);
            return { data, error: null };
        } catch (err) {
            setError(err.message);
            return { data: null, error: err.message };
        } finally {
            setLoading(false);
        }
    };

    return { addRetributionModel, loading, error, uuidResponnse: response };
};

export default useAddRetributionModel;
